var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.empty)?_c('span',{attrs:{"slot":"empty"},slot:"empty"},[_c('i',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.emptyText))])]):_c('span',{attrs:{"slot":"non-empty"},slot:"non-empty"},[_vm._v(_vm._s(_vm.display))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-426d2bb0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/pug-deps-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/optional-cell-value.vue
// module id = odob
// module chunks = 50